
import { Component, HostListener, Inject } from '@angular/core';
import { DOCUMENT, NgStyle } from '@angular/common';
import { environment } from 'src/environments/environment';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-site-header',
    templateUrl: './site-header.component.html',
    standalone: true,
    imports: [NgStyle, MatIconModule]
})

export class SiteHeaderComponent {
  isScroll: boolean = false;
  isInternalUser: boolean = environment.IsInternalUser;

  constructor(@Inject(DOCUMENT) private document: Document) { }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      this.isScroll = true;
    } else {
      this.isScroll = false;
    }
  }
}
